function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1996(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.55,
    height: 10.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 5.28
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.56,
    width: 26.55,
    height: 22.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.78875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 21.715
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.87,
    width: 26.55,
    height: 27.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3100000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 46.5
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.13,
    width: 26.55,
    height: 29.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3100000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 75.015
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.89,
    width: 26.55,
    height: 38.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 109.265
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.65,
    width: 26.55,
    height: 40.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 149.04000000000002
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 169.43,
    width: 26.55,
    height: 44.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.792857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 191.74
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 214.05,
    width: 26.55,
    height: 46.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.792857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 237.17000000000002
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 260.29,
    width: 26.55,
    height: 47.91,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 284.245
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 308.2,
    width: 26.55,
    height: 49.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3100000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 333.02
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 357.84,
    width: 26.55,
    height: 51.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 383.71
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 409.58,
    width: 26.55,
    height: 56.34,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 437.75
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 465.92,
    width: 26.55,
    height: 56.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 494.26
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 522.6,
    width: 26.55,
    height: 56.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 551.02
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.44,
    width: 26.55,
    height: 58.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 608.845
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 638.25,
    width: 26.55,
    height: 61.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.275,
    y: 669.125
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 0,
    width: 35.52,
    height: 46.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5520000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.31,
    y: 23.11
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.07,
    y: 0,
    width: 35.72,
    height: 46.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.93,
    y: 23.11
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.79,
    y: 0,
    width: 37.84,
    height: 46.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7840000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.71000000000001,
    y: 23.11
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.62,
    y: 0,
    width: 40.49,
    height: 46.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.748333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.865,
    y: 23.11
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.11,
    y: 0,
    width: 40.68,
    height: 46.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.811428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.45000000000002,
    y: 23.11
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.79,
    y: 0,
    width: 42.19,
    height: 46.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.218999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.885,
    y: 23.11
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.98,
    y: 0,
    width: 44.69,
    height: 46.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.58625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.32500000000005,
    y: 23.11
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.67,
    y: 0,
    width: 44.96,
    height: 46.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.493333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.15000000000003,
    y: 23.11
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.63,
    y: 0,
    width: 45.29,
    height: 46.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.275,
    y: 23.11
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 0,
    width: 45.99,
    height: 46.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.74875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.925,
    y: 23.11
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.92,
    y: 0,
    width: 47.4,
    height: 46.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.62,
    y: 23.11
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.32,
    y: 0,
    width: 48.77,
    height: 46.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.602857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.705,
    y: 23.11
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.09,
    y: 0,
    width: 53.11,
    height: 46.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.201818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.645,
    y: 23.11
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.2,
    y: 0,
    width: 53.53,
    height: 46.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.703333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.965,
    y: 23.11
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.72,
    y: 0,
    width: 57.28,
    height: 46.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.135555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.36,
    y: 23.11
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 46.22,
    width: 59.54,
    height: 46.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 69.55
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 92.89,
    width: 59.54,
    height: 46.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.379999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 116.34
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 139.79,
    width: 59.54,
    height: 48.37,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 163.975
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 188.16,
    width: 59.54,
    height: 49.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.105714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 213.03
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 237.9,
    width: 59.54,
    height: 50.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.346666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 262.94
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 287.98,
    width: 59.54,
    height: 50.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.178333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 313.05
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 338.11,
    width: 59.54,
    height: 53.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7128571428571435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 365.105
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 392.11,
    width: 59.54,
    height: 59.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.918333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 421.865
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 451.62,
    width: 59.54,
    height: 73.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.954
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 488.295
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 524.96,
    width: 59.54,
    height: 86.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.412727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 568.4200000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 611.89,
    width: 59.54,
    height: 88.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.954
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.32,
    y: 655.9449999999999
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.09,
    y: 46.22,
    width: 70.1,
    height: 81.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.683333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.14,
    y: 87.08500000000001
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.19,
    y: 46.22,
    width: 81.31,
    height: 81.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.16375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.845,
    y: 87.08500000000001
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.5,
    y: 46.22,
    width: 82.4,
    height: 81.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.621666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.7,
    y: 87.08500000000001
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.9,
    y: 46.22,
    width: 84.9,
    height: 81.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.675714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.34999999999997,
    y: 87.08500000000001
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.8,
    y: 46.22,
    width: 90.11,
    height: 81.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.621666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.855,
    y: 87.08500000000001
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.91,
    y: 46.22,
    width: 98.55,
    height: 81.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.21625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 544.1850000000001,
    y: 87.08500000000001
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.46,
    y: 46.22,
    width: 106.54,
    height: 81.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.21625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.73,
    y: 87.08500000000001
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.09,
    y: 127.96,
    width: 117.69,
    height: 75.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.935,
    y: 165.70999999999998
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.09,
    y: 203.46,
    width: 117.69,
    height: 84.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.5475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.935,
    y: 245.65
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.09,
    y: 287.83,
    width: 117.69,
    height: 92.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.935,
    y: 334.29999999999995
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.09,
    y: 380.77,
    width: 117.69,
    height: 128.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.71125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.935,
    y: 445.02
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.09,
    y: 509.27,
    width: 117.69,
    height: 190.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.935,
    y: 604.635
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.78,
    y: 127.96,
    width: 144.43,
    height: 166.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.07166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.995,
    y: 211.22
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.2,
    y: 127.96,
    width: 160.67,
    height: 166.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.606363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.53499999999997,
    y: 211.22
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.87,
    y: 127.96,
    width: 191.13,
    height: 166.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 41.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.435,
    y: 211.22
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.78,
    y: 294.47,
    width: 190.94,
    height: 200.26,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.8675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.25,
    y: 394.6
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.78,
    y: 494.73,
    width: 190.94,
    height: 205.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.277142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.25,
    y: 597.365
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.72,
    y: 294.47,
    width: 148.5,
    height: 267.12,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.97,
    y: 428.03000000000003
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.22,
    y: 294.47,
    width: 156.78,
    height: 267.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.356
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.61,
    y: 428.03000000000003
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.72,
    y: 561.59,
    width: 305.28,
    height: 138.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.06833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.36,
    y: 630.7950000000001
  }, "\n        Nassau\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1996);
export default __webpack_public_path__ + "static/media/1996.ab43e21097f158794701d58cb1a5be5f.svg";
export { ForwardRef as ReactComponent };